import styled from 'styled-components';
import {
  Icon as SemanticIcon,
  Image,
  Progress,
  Button as SemanticButton,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  width: 120px;
  max-height: 38px;
  background-color: #FFF;
  color: #4D5473;
  box-shadow: none;
  border: 1px solid #4D5473;
  border-radius: 3px;
  font-weight: 500;
  margin: 0px;
  padding-left: 15px;
  padding-right: 15px;
  font-family: Roboto;
  min-height: 1em;
  line-height: 1em;
  transition: background-color .1s ease;
  :hover {
    background-color: #DDD;
  }
  :active {
    background-color: #BBB;
  }
  height: 100%;
`;

export const ContainerProgressbar = styled.div`
  display: flex;
  width: 120px;
  align-items: center;
`;

export const ProgressBar = styled(Progress)`
  &&&& {
    margin: 0 10px 0 0;
  }
  &&&& > .bar {
    background-color: #477ae9;
  }
  width: 100%;
  display: flex;
`;

export const Input = styled.input``;

export const Icon = styled(SemanticIcon)`
  &&&& {
    color: ${({ theme }) => (theme.color.text)};
    opacity: 1;
    cursor: pointer;
    height: unset;
  }
`;

export const TrashIcon = styled(Image)`
  cursor: pointer;
  height: 20px;
  margin-right: 10px;
`;

export const Button = styled(SemanticButton)`
  &&&& {
    background-color: transparent;
    border: none;
    color: #FF0000;
    padding: 0;
    box-shadow: none;
    margin: 0 1.4%;
    font-weight: 400;
  }
`;

export const VideoTextContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Text = styled(TextLayoutComponent)`
  font-weight: 500;
`;
